import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import Preloader from "../Preloader";
import NetworkError from "../NetworkError";
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UserContext from "../../contexts/UserContext";
import ProfilCpte from "./profilcpte";




export default function ProfilsAccount({account}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [addable, setAddable] = useState(false);
    const [error, setError] = useState(false);
    const [ruleslist, setProfilList] = useState([]);
    const [rulescodelist, setProfilcodelist] = useState([]);
    const [rulesobjectlist, setProfilobjectlist] = useState([]);

    const [rules, setProfils] = useState("");
    const [rulesalllist, setProfilalllist] = useState([]);

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const getAllListProfils = async () => {
        // setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({label: element.lib, value: element.code});
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (element.ident !== "profilsuperadmin") {
                                clientarraydata2.push({label: element.lib, value: element.code});
                            }
                        });

                        if (user?.isFullAction) {
                            setProfilalllist(clientarraydata);
                        } else {
                            setProfilalllist(clientarraydata2);
                        }
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("serveur error: ", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error: ", err);
            }
            
        }).catch((err) => {
            // console.log("cash error: ", err);
        });
    }


    const getListProfil = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/account/profiles?codecompte=${account}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraycode = [];
                        await clientarray.forEach(element => {
                            clientarraycode.push(element.codeprofil);
                        });

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({label: element.lib, value: element.codeprofil});
                        });

                        // console.log("liste in data", clientarray)
                        setProfilList(clientarray);
                        setProfilcodelist(clientarraycode);
                        setProfilobjectlist(clientarraydata);
                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
            
        })
        .catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }
    


    // comportements
    useEffect(() => {
        getAllListProfils();
        getListProfil();
    }, []);

    const handleSetUpsdate = () => {
        setProfils(rulesobjectlist);
        setAddable(true);
    }

    const handleDelete = async (codeprofil) => {

        const objectrules = [...rulesobjectlist];

        for (let i = 0; i < objectrules.length; i++) {
            const element = objectrules[i];
            if (element.value === codeprofil) {
                objectrules.splice(i, 1);
                setProfilobjectlist(objectrules);
            }
        }

        confirmAlert({
            title: 'Désaffecter?',
            message: 'Etes vous sûr de vouloir désaffecter ce profil à ce compte?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);
                        // console.log("list 2: ", objectrules);
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();
                        urlencoded.append("codeprofil", objectrules.map((i) => i["value"]));

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/account/profiles/${account}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                setFetching(false);
                                showSuccesMessage("Profil désaffecté avec succès à ce compte.");
                                getListProfil();
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    let body = data?.body?.data;

                                    if (body.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(body.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }
                            
                        })
                        .catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codeprofil", rules.map((i) => i["value"]));

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/account/profiles/${account}`, requestOptions).then((response) => {
            if (response?.status === 204) {
                setFetching(false);
                showSuccesMessage("Profils du compte mis à jour avec succès");
                setAddable(false);
                getListProfil();
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse update rule", data);
                    let body = data?.body?.data;

                    if (body.msg === "expiredsession") {
                        logoutUser();
                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                    } else {
                        setFetching(false);
                        showErrorMessage(body.msg);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }
            
        })
        .catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
            setFetching(false);
        });
    }

    // console.log("objet list: ", rulesobjectlist);

    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3 pt-3 rounded" style={{borderTop: "1px solid #ccc"}}>
                    <div className="row">
                        {/* <div className="col-md-2 mb-3">  
                            <PaginationSelect table={"scan"} getList={getListProfil} page={page} setPage={setPage} limit={100} current={currentpage} setCurrent={setCurrentpage} />
                        </div>
                        <div className="col-md-10 mb-3">
                            <Search 
                                chaine={chaine}
                                setChaine={setChaine}
                                search={searchScan}
                                placeholder="Search by access name..."
                            />
                            <Filterdate 
                                date={date}
                                setDate={setDate}
                                filterdate={filterByDate}
                                placeholder="Filter by date..."
                            />
                            <Filterselect 
                                list={list}
                                item={mode}
                                setItem={setMode}
                                filterselect={filterByMode}
                                placeholder="Filter by access types..."
                            />
                        </div> */}
                        {!addable && <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <button type="button" data-toggle="tooltip" onClick={handleSetUpsdate}
                                        title="Mise à jour des profils du compte" 
                                        data-placement="left" className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Mettre à jour</span>
                                    </button>
                                    <h6 className="m-0 ">Liste des profils du compte</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive mb-3">
                                        <table className="mb-0 table table-bordered">
                                            <thead className="bg-primary">
                                                <tr className="bg-primary text-white">
                                                    <th className="text-center">#</th>
                                                    <th>Libelle</th>
                                                    {/* <th>Code action</th> */}
                                                    {/* <th>Parent</th>
                                                    <th>Etat</th>
                                                    <th>Date d'affectation</th> */}
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(ruleslist.length === 0) && <tr style={{borderStyle: "none"}}>
                                                    <th colSpan={3} className="text-center">Aucune profil trouvé pour ce compte</th>
                                                </tr>}
                                                {
                                                    (ruleslist.length > 0) && ruleslist?.map((item, index) => (
                                                        <ProfilCpte profile={item} position={index} key={index} 
                                                            deleteClick={() => handleDelete(item?.codeprofil)}
                                                        />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <Pagination table={"client"} getList={getListProfil} page={page} setPage={setPage} /> */}
                                </div>
                            </div>
                        </div>}
                        {addable && <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <button type="button" data-toggle="tooltip" onClick={() => setAddable(false)}
                                        title="Annuler la mise à jour" 
                                        data-placement="left" className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-backward mr-1"></i> <span>Annuler</span>
                                    </button>
                                    <h6 className="m-0 ">Mettre à jour les profils de ce compte</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    
                                                    <div className="col-md-12 mb-3">
                                                        <label className="mb-1" htmlFor="parent">Profils</label>
                                                        <Select
                                                            id="parent"
                                                            name="parent"
                                                            options={rulesalllist}
                                                            value={rules}
                                                            placeholder="Sélectionnez les profils du compte"
                                                            onChange={(selected) => { 
                                                                setProfils(selected);
                                                            }}
                                                            isMulti
                                                        />
                                                    </div>
                                                    
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Ajouter les profils au compte" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    disabled={rules ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Ajouter</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>} 
        </>
    )
    
}